import { App } from "@engine";
import { MorphHexGame } from "@game/MorphHexGame";
import { morphHexManifest } from "@game/assets/manifest";

async function boot(): Promise<void> {
  const canvas = document.querySelector<HTMLCanvasElement>("canvas#stage");
  if (!canvas) {
    throw new Error("MORPH-HEX: <canvas#stage> not found in DOM");
  }

  const app = new App({ canvas });
  app.assets.register(morphHexManifest);

  const game = new MorphHexGame(app);
  app.start();

  await game.preload();
  game.showMenu();
}

void boot().catch((err) => {
  console.error("[MORPH-HEX] boot failed:", err);
  const hud = document.getElementById("hud-loading");
  if (hud) {
    hud.querySelector(".subtitle")!.textContent = "Boot failed - check console.";
  }
});
